import React from 'react';
import { Pagination as AntPagination } from "antd";
import { useSelector} from "react-redux";

import { getFilersSelector } from "services/filters/filters.selector";
import StyledPagination from "components/Pagination/styled/StyledPagination";

const PAGINATION_LIMIT = 50;

const Pagination = ({ request, total, name, ...props }) => {
    const filters = useSelector((state) => getFilersSelector(state, name));

    const handleChange = (page) => {
        request({ ...filters, _start: page * PAGINATION_LIMIT - 50, _limit: PAGINATION_LIMIT })
    };
    return (
        <StyledPagination>{
            (total > PAGINATION_LIMIT)
            && <AntPagination  onChange={handleChange} total={total} {...props} />
        }</StyledPagination>
    )
};

export default Pagination;